import React from "react";
import "./moredetails.css"
import { Row,Col,Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";


const MovieDetails = (props) => {


  const { t } = useTranslation(["translation"]);
 
     

    return(
    <Container>
     <Row>
         <Col sm={12}>
         <div className="play-details-content">
      <div className="title-block d-flex align-items-center justify-content-between">
        <h2 className="play-title">{t("label_Synopsis")}</h2>
      </div>
      {/* Title Block */}
      <div className="details-desc">
        <p>{props.data.description}</p>
      </div>
      {/* Details Desc */}
      <div className="movie-persons mb-4">
        <div className="person-block">
          <h5 className="title">{t("label_Director")}</h5>
          <p className="name">{props.data.Director}</p>
        </div>
        {/* Person Block */}
        <div className="person-block">
          <h5 className="title">{t("label_Studio")}</h5>
          <p>{props.data.ProductionStudio}</p>
        </div>
        {/* Person Block */}
      </div>
      {/* Movie Persons */}
      <div className="movie-persons mb-4">
        <div className="person-block">
          <h5 className="title">{t("label_Genre")}</h5>
          <p className="name">{props.data.Genre}</p>
        </div>
        {/* Person Block */}
        <div className="person-block">
          <h5 className="title">{t("label_Written_By")}</h5>
          <p>{props.data.Writers}</p>
        </div>
        {/* Person Block */}
      </div>
      {/* Movie Persons */}
      
      {/* Details Buttons End */}
    </div>
      
         </Col>
     </Row>
     
    </Container>
     
      );
      
}

export default MovieDetails;